import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

const encryptSecretKey = '@mp1u5';

@Injectable()
export class EncriptyUtilService {
  encriptyBySecretKey(data:any){
    return encriptyBySecretKeyFuntion(data);
  }  

  decriptyBySecretKey(data:any){
    return decriptyBySecretKeyFunction(data);
  }  

}

export function encriptyBySecretKeyFuntion(data: any) {
  let iv = CryptoJS.lib.WordArray.random(16);
  return CryptoJS.AES.encrypt(data, encryptSecretKey, {iv: iv});
}

export function decriptyBySecretKeyFunction(data: any) {
  if(data != null && data !== 'null'){
    let iv = CryptoJS.lib.WordArray.random(16);
    let bytes = CryptoJS.AES.decrypt(data, encryptSecretKey, {iv: iv});
    return bytes.toString(CryptoJS.enc.Utf8);
  }
  return data;
}
